import { styled } from '@mui/system'
import { motion } from 'framer-motion'

export const AnimatedDiv = styled(motion.div)``
